import { render, staticRenderFns } from "./ProvidersList.vue?vue&type=template&id=7e3c59c7&"
import script from "./ProvidersList.vue?vue&type=script&lang=js&"
export * from "./ProvidersList.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersList.vue?vue&type=style&index=0&id=7e3c59c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports